<template>
    <div>
        <el-dialog v-if="dialogVisibleMlytShow" v-el-drag-dialog :close-on-click-modal="false" :title="'查看会议'" :visible.sync="dialogVisibleMlytShow" width="1300px">
            <div>
                <el-tabs v-model="activeName" class="meet_info_tabs" @tab-click="handleClick">
                    <el-tab-pane label="会议信息" name="first"></el-tab-pane>
                    <el-tab-pane :label="'会议议程('+meetCount+')'" name="second"></el-tab-pane>
                    <el-tab-pane label="会议排座" name="third"></el-tab-pane>
                    <!-- <el-tab-pane label="会议回执" name="fourth"></el-tab-pane> -->
                    <el-tab-pane label="会议报名" name="fourth"></el-tab-pane>
                    <el-tab-pane label="会议签到" name="fifth"></el-tab-pane>
                    <el-tab-pane label="会议决议" name="sixth"></el-tab-pane>
                    <el-tab-pane label="会议纪要" name="seventh"></el-tab-pane>
                    <el-tab-pane label="变更记录" name="eighth"></el-tab-pane>
                </el-tabs>
                <div class="meet_info_content">
                    <template v-if="activeName === 'first'">
                        <MeetInfo :message-flag="messageFlag" :row="rowData" :can-edit="canEdit" />
                    </template>
                    <!-- <template v-if="activeName === 'second'">
                        <HyycInfo :row="rowData" :can-edit="canEdit" />
                    </template> -->
                    <span v-show="activeName === 'second'">
                        <HyycInfo :row="rowData" :can-edit="canEdit" />
                    </span>
                    <template v-if="activeName === 'third'">
                        <HypzInfo :row="rowData" :can-edit="canEdit" :meet-count="meetCount" />
                    </template>
                    <template v-if="activeName === 'fourth'">
                        <!-- <HyhzInfo :row="rowData" :can-edit="canEdit" /> -->
                        <HybmInfo :row="rowData" :can-edit="canEdit" />
                    </template>
                    <template v-if="activeName === 'fifth'">
                        <QdxxInfo :row="rowData" :can-edit="canEdit" />
                    </template>
                    <template v-if="activeName === 'sixth'">
                        <VoteInfo :row="rowData" :can-edit="canEdit" />
                    </template>
                    <template v-if="activeName === 'seventh'">
                        <HyjyInfo :row="rowData" :can-edit="canEdit" />
                    </template>
                    <template v-if="activeName === 'eighth'">
                        <BgjlInfo :row="rowData" :can-edit="canEdit" />
                    </template>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleMlytShow = false">{{ $tx('hygl.cancel','取 消') }}</el-button>
                <el-button v-if="canEdit" type="primary" @click="SignforConfirm">{{ $tx('hygl.submit','提 交') }}</el-button>
            </span>
        </el-dialog>
         <el-dialog v-if="dialogQrCodeVisible" v-el-drag-dialog title="签到二维码" :append-to-body="true" :visible.sync="dialogQrCodeVisible" width="800px">
            <div class="contQR">
                <h3 style="text-align: center">{{ rowData.flSubject }}</h3>
                <span v-text-lbl="'scanSignin'" style="text-align: center; display: block; margin-top: 10px">扫描二维码签到</span>
                <img :src="imageUrl" alt="" />
                <p v-text-lbl="'meetingAddress'" style="text-align: left" :place="rowData.meetPlace">会议地点：{{ rowData.meetPlace }}</p>
                <p v-text-lbl="'meetingPerson'" style="text-align: left" :person="rowData.flCreator">召集人：{{ rowData.flCreator }}</p>
                <p v-text-lbl="'meetingPhone2'" style="text-align: left" :phone="rowData.flCreatorPhone">联系电话:{{ rowData.flCreatorPhone }}</p>
                <p v-text-lbl="'meetingTime3'" style="text-align: left;width: 400px;" :time="(rowData.startTime | formatTime) + '-' + (rowData.endTime | formatTime)">会议时间：{{ rowData.startTime | formatTime }} - {{ rowData.endTime | formatTime }}</p>
            </div>
        </el-dialog>
        <el-dialog v-el-drag-dialog :title="$tx('hygl.components.hyglTitle', '补发会议通知')" :visible.sync="bfhytzShow" width="1000px">
            <div>
                <el-form :model="bftzObj">
                    <div style="width: 100%" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table v-if="bfhytzShow" cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                <tbody>
                                    <tr>
                                        <td ref="tdlbl_补发范围 " class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'bfTime'" class="field">选择补发范围</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="2">
                                            <form-item
                                                ref="meetShape"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: $tx('hygl.components.selectBfRangeElementFormatter', '1：选择人员\n2：选择部门'),
                                                    elementReadonly: 0,
                                                    elementType: 'radio',
                                                    emptyMessage: $tx('hygl.components.selectBfRangeEmptyMessage', '请选择补发范围'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '补发范围 ',
                                                    propName: 'meetShape',
                                                    propType: 'Short',
                                                    textFormatter: null,
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'bftzObj.meetShape',
                                                    option: [
                                                        { value: '1', name: $tx('hygl.components.selectPerson', '选择人员') },
                                                        { value: '2', name: $tx('hygl.components.selectDepart', '选择部门') }
                                                    ],
                                                    optionGenerateType: 0,
                                                    clearable: true,
                                                    filterable: false,
                                                    allowCreate: false
                                                }"
                                                :vo="bftzObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr v-if="bftzObj.meetShape == 1" :key="1001">
                                        <td ref="tdlbl_选择人员" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'attendName'" class="field">参会人员</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                ref="attendName"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: $tx('hygl.components.selectPersonEmptyMessage', '请选择人员'),
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '选择人员',
                                                    propName: 'attendName',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: 1073741823,
                                                    valueMinLength: null,
                                                    model: 'bftzObj.attendName',
                                                    option: [],
                                                    autocomplete: 'off',
                                                    showWordLimit: false,
                                                    dialog: 1,
                                                    dialogType: 'staff',
                                                    dialogOrgLevel: '',
                                                    dialogSelectedOrderBy: 'orgOrderNo',
                                                    dialogMultiple: true,
                                                    dialogOrgSelf: false
                                                }"
                                                :vo="bftzObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr v-if="bftzObj.meetShape == 2" :key="1002">
                                        <td ref="tdlbl_选择部门" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'attendName'" class="field">参会人员</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                ref="attendName"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: '',
                                                    errorMessage: null,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '选择部门',
                                                    propName: 'attendName',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: 100,
                                                    valueMinLength: null,
                                                    tbFieldName: 'attendname',
                                                    model: 'bftzObj.attendName',
                                                    option: [],
                                                    formTdAlign: 'text-left',
                                                    autocomplete: 'off',
                                                    showWordLimit: false,
                                                    dialog: 1,
                                                    dialogType: 'suborg',
                                                    dialogOrgLevel: '2',
                                                    dialogMultiple: true
                                                }"
                                                :vo="bftzObj"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'cancel'" @click="bfhytzShow = false">取消</el-button>
                <el-button v-pageBtn-lbl="'sure'" type="primary" :loading="doing" @click="saveBtn">确 定</el-button>
            </span>
        </el-dialog>
        <HytzHyyt />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
const moment = require('moment')
import HytzHyyt from '../hytzHygl/hytzHyytDialog.vue'
import MeetInfo from './components/meetInfo.vue'
import HyycInfo from './components/hyycInfo.vue'
import HypzInfo from './components/hypzInfo.vue'
// import HyhzInfo from './components/hyhzInfo.vue'
import HybmInfo from './components/hybmInfo.vue'
import QdxxInfo from './components/qdxxInfo.vue'
import VoteInfo from './components/voteInfo.vue'
import HyjyInfo from './components/hyjyInfo.vue'
import BgjlInfo from './components/bgjlInfo.vue'
export default {
    components: {
        HytzHyyt, MeetInfo, HypzInfo, VoteInfo, HyycInfo, HybmInfo, QdxxInfo, HyjyInfo, BgjlInfo
    },
    filters: {
        formatTime: function (val) {
            if (val) {
                return moment().format('YYYY-MM-DD HH:mm')
            }
            return val
        }
    },
    props: {},
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            loginUser: this.$store.getters.loginUser,
            dialogVisibleMlytShow: false,
            dialogQrCodeVisible: false,
            imageUrl: '',
            doing: false,
            activeName: 'first',
            rowData: {},
            actionType: false,
            messageFlag: 0,
            bfhytzShow: false,
            bftzObj: {
                attendName: null,
                attendId: null,
                meetShape: 1
            },
            canEdit: 1,
            meetCount: 0
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {

    },
    created() {
        this.$bus.on('openMeetInfoDialog', this.openMeetInfoDialog)
    },
    beforeDestroy() {
        this.$bus.off('openMeetInfoDialog', this.openMeetInfoDialog)
    },
    mounted() {},
    methods: {
        async SignforConfirm(noresh) {
            console.log('确定', this.rowData)
            console.log('确定', this)
            debugger
            const _this = this
            this.rowData.status = 2

            var orderNo = 1000
            this.rowData.passenger.batchUpdate.forEach(item => {
                item.orderNo = orderNo
                orderNo++
            })

            if (!this.rowData.passenger.attachsList) this.rowData.passenger.attachsList = []
            this.uploadAttach(this.rowData.passenger.attachsList).then(result => {
                if (result.code === 'success') {
                    delete this.rowData.passenger.attachsList
                    this.$http({
                        method: 'post',
                        url: `/hygl/hyap/changeInfo?messageFlag=${_this.messageFlag}`,
                        data: _this.rowData
                    }).then((res) => {
                        if (res.code === 'success') {
                            _this.dialogVisibleMlytShow = false
                            _this.rowData = {}
                            this.$bus.emit('refreshListData')
                            this.$message.success(res.message)
                        } else {
                            this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                        }
                    })
                }
            })
        },
        uploadAttach(list) {
            const _this = this
            const files = list.filter(item => !item.id)
            return new Promise((resolve, reject) => {
                if (files.length === 0) {
                    resolve({code: 'success', message: '暂无附件上传'})
                }
                const array = []
                files.forEach((item, index) => {
                    const fd = new FormData()
                    fd.append('file', item.file.raw)
                    fd.append('module', 'hyap')
                    fd.append('attachsSize', item.file.size)
                    fd.append('busiDataId', _this.rowData.id)
                    fd.append('attachsType', 'ATTACH')
                    fd.append('attachsName', item.file.name)
                    fd.append('uploadBy', _this.loginUser.personName)
                    fd.append('uploadById', _this.loginUser.userId)
                    array.push(this.$http({
                        method: 'POST',
                        url: 'hygl/hyap/upload',
                        data: fd
                    }))
                })
                Promise.all(array).then(res => {
                    if (res.length === files.length) {
                        resolve({ code: 'success', message: '附件上传成功' })
                    } else {
                        resolve({ code: 'error', message: '附件上传失败' })
                    }
                })
            })
        },
        openMeetInfoDialog(row, type = 'first', canEdit = 1) {
            var _this = this
            this.rowData = row
            this.canEdit = canEdit
            this.rowData.passenger.meetDirectoryIds = '' //  绑定目录
            this.rowData.passenger.cancelDirectory = '' //  取消绑定会议目录
            // this.rowData.passenger.relevanceYtRecord = { 'meetDirectoryId': '', 'ytRecordLists': 'yyy,xxx' }, //  添加议题到目录
            this.rowData.passenger.deleteYtRecord = '' //  删除议题
            this.rowData.passenger.batchUpdate = [] //  排序议题
            this.dialogVisibleMlytShow = true
            this.activeName = type
            // setTimeout(() => {
            //     this.$bus.emit('meetInfoFirst', row)
            // }, 100)
        },
        handleClick(val) {
            console.log(val)
            if (val.name === 'first') {
                this.$bus.emit('meetInfoFirst', this.rowData)
            } else if (val.name === 'second') {
                this.$bus.emit('meetInfoSecond', this.rowData)
            } else if (val.name === 'third') {
                // this.$bus.emit('meetInfoSecond', this.rowData)
            } else if (val.name === 'fourth') {
                // this.$bus.emit('meetInfoFourth', this.rowData)
            } else if (val.name === 'fifth') {
                // this.$bus.emit('meetInfoFourth', this.rowData)
            } else if (val.name === 'sixth') {
                this.$bus.emit('meetInfoSixth', this.rowData)
            } else if (val.name === 'seventh') {
                this.$bus.emit('meetInfoSeventh', this.rowData)
            } else if (val.name === 'eighth') {
                this.$bus.emit('meetInfoEighth', this.rowData)
            }
        },
        handleClose(done) {},
        // 获取二维码
        async openQrCode(row) {
            const _this = this
            this.rowData = row
            this.dialogQrCodeVisible = true
            await this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                url: '/base/paramConfig/findParamValueByName',
                params: {
                    orgCode: _this.loginUser.orgCode,
                    paramName: 'mpp.h5app.baseurl'
                }
            }).then((res) => {
                if (res.code === 'success') {
                    var urlStr = res.body.value + '#/QRwaiting?apigateway=' + location.host + '&meetId=' + _this.rowData.id + ''
                    urlStr = encodeURI(urlStr)
                    this.$http({
                        method: 'GET',
                        contentType: 'application/x-www-form-urlencoded',
                        url: '/hygl/hyap/getQrCode',
                        params: {
                            url: urlStr
                        }
                    }).then((res) => {
                        if (res.code === 'success') {
                            _this.imageUrl = 'data:image/png;base64,' + res.body.image
                        } else {
                            _this.$message.error(res.message)
                        }
                    })
                } else {
                    this.$message.error(this.$tx('hygl.message.noFindH5', '未检测到h5参数！请联系管理员'))
                }
            })
        },
        // 补发通知
        openBftz(row) {
            this.bftzObj.meetShape = row.meetShape
            this.bftzObj.attendName = null
            this.bftzObj.attendId = null
            this.rowData = row
            this.bfhytzShow = true
        },
        // 确认补发
        saveBtn() {
            if (this.bftzObj.attendId) {
                this.doing = true
                this.$http({
                    method: 'post',
                    url: '/hygl/hyap/reissue',
                    params: {
                        receptionIds: this.bftzObj.attendId,
                        type: this.bftzObj.meetShape
                    },
                    data: this.rowData
                }).then((res) => {
                    this.doing = false
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.bfhytzShow = false
                    } else {
                        this.$message.error(res.message)
                    }
                })
            } else {
                this.$message.warning(this.$tx('hygl.message.selectPerson'))
            }
        },
        onSelectSuborgCompleted(node, attr) {
            const names = []
            const ids = []
            node.forEach((item) => {
                names.push(item.name)
                ids.push(item.id)
            })

            if (attr.name === 'attendName') {
                this.bftzObj.attendName = names.join('、')
                this.bftzObj.attendId = ids.join(',')
            }
        },
        onSelectStaffCompleted(node, attr) {
            const names = []
            const ids = []
            node.forEach((item) => {
                names.push(item.name)
                ids.push(item.id)
            })

            if (attr.name === 'attendName') {
                this.bftzObj.attendName = names.join('、')
                this.bftzObj.attendId = ids.join(',')
            }
        }
    }
}
</script>

<style scoped lang="scss">
.contQR {
    width: 372px;
    height: 500px;
    margin: 0 auto;
    h3,
    h4 {
        margin: 0;
    }
    img {
        width: 340px;
        height: 340px;
        margin: 0 auto;
    }
    p {
        margin: 0;
        padding: 0 40px;
    }
}
/deep/.el-range-editor--medium .el-range-separator {
    line-height: 35px !important;
    margin-right: 3px;
}
</style>
